import { createSlice } from "@reduxjs/toolkit";

import { ChatbotRTKService } from "../app/services/chatbot-rtk.services";
import { RootState } from "../app/store";
import { Plans } from "../constants/plans.constant";
import IDashboardState from "../interfaces/models/dashboard-state.interface";
import IPackage from "../interfaces/models/package.interface";

const initialState: IDashboardState = {
  isFloatSideMenuShow: false,
  isSideMenuShow: false,
  isSideMenuSize: "sm",
  redirectToEnableLocalUse: false,
  chosenPlan: null,
  isDefaultPackage: false,
  currentPackage: null,
  widgetCustomize: null,
  linkCustomize: null,
  Code: null,
  permission: {
    isAccessAIkitty: false,
    isAccessScenario: false,
    isCustomizeChatInterface: false,
    isAssistant: false,
    isCloneActive: false,
    isWidgetActive: false
  },
  permissionList: [],
  Client: null,
  permissions: undefined,
  save_conversation: false,
  Currency: "USD"
};

export const DashboardSlice: any = createSlice({
  name: "DashboardSlice",
  initialState,
  reducers: {
    setIsFloatSideMenuShow: (state: IDashboardState, action) => {
      state.isFloatSideMenuShow = action.payload;
      state.isSideMenuShow = !action.payload;
      // state.isSideMenuSize = "lg";
    },
    setRedirectToEnableLocalUse: (state: IDashboardState, action) => {
      state.redirectToEnableLocalUse = action.payload;
    },

    setSideMenuSize: (state: IDashboardState, action) => {
      state.isSideMenuSize = action.payload;
    },

    setChosenPlan: (state: IDashboardState, action) => {
      state.chosenPlan = action.payload;
    },

    setCurrency: (state: IDashboardState, action) => {
      state.Currency = action.payload;
    },
    resetDashboard: () => initialState
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      ChatbotRTKService.endpoints.getPackage.matchFulfilled,
      (state, action) => {
        if (action?.payload?.permissions) {
          state.permissions = action?.payload?.permissions;
        }

        if (action?.payload?.code) {
          state.Code = action?.payload?.code;
        }

        if (action?.payload?.plan) {
          const packageData = Plans.find(
            (dr) => dr.name == action?.payload?.plan
          );

          if (packageData) {
            state.isDefaultPackage = true;
            state.currentPackage = {
              active: true,
              button: packageData.button,
              buttonClass: packageData.buttonClass,
              discountDescription: packageData.discountDescription,
              discountIcon: packageData.discountIcon,
              expireTime: action?.payload?.plan.expiredAt,
              features: packageData.features,
              headerTitle: packageData.headerTitle,
              headerTitleClass: packageData.headerTitleClass,
              is_user_new_button: packageData.is_user_new_button,
              isDiscount: packageData.isDiscount,
              isMonthly: packageData?.isMonthly,
              name: packageData.name,
              price: packageData.price,
              priceDescription: packageData.priceDescription,
              title: packageData.title,
              discountLine: packageData.discountLine,
              icon: packageData.icon
            } as IPackage;
          }

          // if (action?.payload?.permissions) {
          //
          //   state.permissionList = action?.payload?.permissions;
          //   state.permission.isAccessAIkitty =
          //     action?.payload?.permissions.some(
          //       (x: string) => x == "bot_KITTY_01"
          //     );
          //   state.permission.isAccessScenario =
          //     action?.payload?.permissions.some(
          //       (x: string) => x == "bot_MCBOT_01"
          //     );
          //   state.permission.isCustomizeChatInterface =
          //     action?.payload?.permissions.some(
          //       (x: string) => x == "widget_style"
          //     );
          //   state.permission.isAssistant = action?.payload?.permissions.some(
          //     (x: string) => x == "bot_KITTY_02"
          //   );

          //   state.permission.isWidgetActive =
          //     action?.payload.activeBot != null ? true : false;
          //   state.permission.isCloneActive =
          //     action?.payload.activeClone != null ? true : false;
          // }

          // if (packageData) {
          //   state.isDefaultPackage = true;
          //   state.currentPackage = {
          //     active: true,
          //     button: packageData.button,
          //     buttonClass: packageData.buttonClass,
          //     discountDescription: packageData.discountDescription,
          //     discountIcon: packageData.discountIcon,
          //     expireTime: action?.payload?.plan.expiredAt,
          //     features: packageData.features,
          //     headerTitle: packageData.headerTitle,
          //     headerTitleClass: packageData.headerTitleClass,
          //     is_user_new_button: packageData.is_user_new_button,
          //     isDiscount: packageData.isDiscount,
          //     isMonthly: packageData?.isMonthly,
          //     name: packageData.name,
          //     price: packageData.price,
          //     priceDescription: packageData.priceDescription,
          //     title: packageData.title,
          //     discountLine: packageData.discountLine,
          //     icon: packageData.icon
          //   } as IPackage;
          // }

          // if (action?.payload?.permissions) {
          //   state.permission.isAccessAIkitty =
          //     action?.payload?.permissions.some(
          //       (x: string) => x == "bot_KITTY_01"
          //     );
          //   state.permission.isAccessScenario =
          //     action?.payload?.permissions.some(
          //       (x: string) => x == "bot_MCBOT_01"
          //     );
          //   state.permission.isCustomizeChatInterface =
          //     action?.payload?.permissions.some(
          //       (x: string) => x == "widget_style"
          //     );
          //   state.permission.isAssistant = action?.payload?.permissions.some(
          //     (x: string) => x == "bot_KITTY_02"
          //   );
          // }

          if (action?.payload?.config) {
            if (action?.payload?.config?.widget_defaults) {
              const widget = action?.payload?.config?.widget_defaults;
              state.widgetCustomize = {
                color: widget.color,
                icon: { ...widget.icon },
                isOpen: widget.isOpen,
                name: widget.name,
                position: widget.position,
                poweredBy: widget.poweredBy,
                theme: widget.theme,
                showInitialMessage: widget.show_initial_message,
                imageUrl: widget.logo,
                isVoiceActive: widget.isVoiceActive ? true : false,
                autoInstall: widget.autoInstall || false,
                domain: widget.domain || "",
                isVisible: widget.isVisible || false,
                workOnDesktop: widget.workOnDesktop || false,
                save_conversation: widget.save_conversation || false,
                alwaysShowButtons: widget.alwaysShowButtons,
                voiceResponse: widget.voiceResponse,
                operatingHours: {
                  isActive: widget?.operatingHours?.isActive || false,
                  times: widget?.operatingHours?.times
                    ? { ...widget?.operatingHours?.times }
                    : {
                        mon: [{ from: "", to: "" }],
                        tue: [{ from: "", to: "" }],
                        wed: [{ from: "", to: "" }],
                        thu: [{ from: "", to: "" }],
                        fri: [{ from: "", to: "" }],
                        sat: [{ from: "", to: "" }],
                        sun: [{ from: "", to: "" }],
                        exc: [{ from: "", to: "" }]
                      }
                }
              };
            }
            if (action?.payload?.config?.link_defaults) {
              const link = action?.payload?.config?.link_defaults;
              state.linkCustomize = {
                color: link.color,
                icon: +link.icon,
                isOpen: link.isOpen,
                name: link.name,
                position: link.position,
                poweredBy: link.poweredBy,
                theme: link.theme,
                showInitialMessage: link.show_initial_message,
                imageUrl: link.logo,
                isVoiceActive: link.isVoiceActive ? true : false
              };
            }
          }
        }

        if (action?.payload) {
          state.Client = action?.payload;
        }
      }
    );
  }
});

export const {
  setIsFloatSideMenuShow,
  setRedirectToEnableLocalUse,
  resetDashboard,
  setChosenPlan,
  setSideMenuSize,
  setCurrency
} = DashboardSlice.actions;

export const selectFloatSideMenuShow = (state: RootState) =>
  (state.dashboardState as IDashboardState).isFloatSideMenuShow;

export const selectSideMenuSize = (state: RootState) =>
  (state.dashboardState as IDashboardState).isSideMenuSize;

export const selectSideMenuShow = (state: RootState) =>
  (state.dashboardState as IDashboardState).isSideMenuShow;

export const selectRedirectToEnableLocalUse = (state: RootState) =>
  (state.dashboardState as IDashboardState).redirectToEnableLocalUse;

export const selectChosenPlan = (state: RootState) =>
  (state.dashboardState as IDashboardState).chosenPlan;

export const selectCurrentPackage = (state: RootState) =>
  (state.dashboardState as IDashboardState).currentPackage;

export const selectPermission = (state: RootState) =>
  (state.dashboardState as IDashboardState).permission;

export const selectPermissionList = (state: RootState) =>
  (state.dashboardState as IDashboardState).permissionList;

export const selectWidgetCustomize = (state: RootState) =>
  (state.dashboardState as IDashboardState).widgetCustomize;

export const selectLinkCustomize = (state: RootState) =>
  (state.dashboardState as IDashboardState).linkCustomize;

export const selectClient = (state: RootState) =>
  (state.dashboardState as IDashboardState).Client;

export const selectPermissions = (state: RootState) =>
  (state.dashboardState as IDashboardState).permissions;

export const selectCurrency = (state: RootState) =>
  (state.dashboardState as IDashboardState).Currency;

export default DashboardSlice.reducer;
